import { createContext, PropsWithChildren, useState } from 'react'
import { Sponsor } from 'domain/models/Sponsor/Sponsor'
import { AuthModals } from './AuthModals'

export type ModalState =
  | 'CLOSED'
  | 'SIGNUP'
  | 'SIGNIN'
  | 'WELCOME'
  | 'FORGOT_PASSWORD'
  | 'FORGOT_PASSWORD_SUCCESS'
  | 'SPONSOR'

interface ModalStateContext {
  modalParams: ModalParams
  setModalParams: (params: ModalParams) => void
}

export const AuthModalContext = createContext<ModalStateContext>({
  modalParams: {
    state: 'CLOSED',
    redirectUrl: ''
  },
  setModalParams: () => {}
})

interface ModalParams {
  state: ModalState
  redirectUrl: string
  email?: string
  sponsors?: Sponsor[]
}

export const AuthModalContextProvider = ({ children }: PropsWithChildren) => {
  const [modalParams, setModalParams] = useState<ModalParams>({
    state: 'CLOSED',
    redirectUrl: ''
  })

  return (
    <AuthModalContext.Provider
      value={{
        modalParams,
        setModalParams
      }}
    >
      <AuthModals />
      {children}
    </AuthModalContext.Provider>
  )
}
